import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { useShopAdminAuth } from '../../context/ShopAdminAuthContext';

export default function ShopAdminLogin() {
  const { staff, login } = useShopAdminAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (staff) return <Navigate to="/shop-admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast.success('Signed in to Shop Admin');
      navigate('/shop-admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 via-background to-background px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-border p-8">
        <div className="flex items-center gap-3 mb-1">
          <img src="/bison-logo.png" alt="Bison" className="h-10" />
          <div>
            <div className="font-serif font-bold text-xl leading-tight">Bison Shop</div>
            <div className="text-xs text-muted-foreground uppercase tracking-wider">Back-office</div>
          </div>
        </div>
        <h1 className="text-2xl font-serif font-bold mt-6">Sign in</h1>
        <p className="text-sm text-muted-foreground mb-5">Staff portal for the Bison online shop.</p>
        <form onSubmit={submit} className="space-y-3" data-testid="shop-admin-login-form">
          <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm(f => ({...f, email: e.target.value}))} data-testid="shop-admin-email" /></div>
          <div><Label>Password</Label><Input type="password" required value={form.password} onChange={(e) => setForm(f => ({...f, password: e.target.value}))} data-testid="shop-admin-password" /></div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="shop-admin-submit">{busy ? 'Signing in…' : 'Sign in'}</Button>
        </form>
        <p className="text-xs text-muted-foreground mt-4 text-center">For the management system, go to <a href="/login" className="text-primary hover:underline">/login</a> instead.</p>
      </div>
    </div>
  );
}
